<div class="container" *ngIf="auditClaimUpdate$ | async as auditClaimUpdate">
  <div class="loading-overlay" *ngIf="auditClaimUpdate.pending">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>

  <div class="container__form" [formGroup]="form">
    <div class="control-wrap">
      <kendo-formfield>
        <kendo-label [for]="statusSelect" text="Status"> </kendo-label>
        <kendo-dropdownlist
          #statusSelect
          class="k-dropdownlist-width-legacy"
          formControlName="status"
          [data]="statusOptions"
          [valuePrimitive]="true"
          textField="text"
          valueField="value"
        ></kendo-dropdownlist>
      </kendo-formfield>
    </div>

    <div class="text-area-row">
      <div class="control-wrap">
        <kendo-formfield>
          <kendo-label [for]="reasonTextInput" text="Reason Text">
          </kendo-label>
          <kendo-textarea
            #reasonTextInput
            class="form-field textarea"
            formControlName="reasonText"
            resizable="auto"
            [maxlength]="1000"
          >
          </kendo-textarea>
        </kendo-formfield>
      </div>
    </div>
  </div>

  <kendo-dialog-actions class="container__toolbar">
    <div class="container__buttons">
      <button kendoButton class="container__button" (click)="close()">
        Cancel
      </button>
      <button
        kendoButton
        [primary]="true"
        class="container__button"
        (click)="submit()"
        [disabled]="form.pristine || form.invalid || auditClaimUpdate.pending"
      >
        Save
      </button>
    </div>
  </kendo-dialog-actions>
</div>
